<div class="container">

<div class="row">

  <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div class="card-header font-weight-B fs-1r">Add Admin</div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4" ></div>
          <div class="col-md-4">
            <label for="">Admin Name / Username: </label>
            <input type="text" [(ngModel)]="adminName" class="form-control" placeholder="Admin name">
          </div>
          <div class="col-md-4" ></div>
        </div>
  
        <div class="row mt-2">
          <div class="col-md-4" ></div>
          <div class="col-md-4">
            <label for="">Admin Password : </label>
            <input type="password" [(ngModel)]="adminPassword" class="form-control" placeholder="Admin password">
          </div>
          <div class="col-md-4" ></div>
        </div>
  
        <div class="row mt-2">
          <div class="col-md-4" ></div>
          <div class="col-md-4">
            <label for="">Admin Type : </label>
            <select name="" id=""  [(ngModel)]="adminType"  class="form-control" >
              <option value="">Select Admin Type</option>
              <option value="Super Admin">Super Admin</option>
              <option value="Sub Admin">Sub Admin</option>
              <option value="Editor">Editor</option>
            </select>

            <div class="mt-2 mb-2">
                <div>
                  <label for=""> Module Access : </label> <br>
                         <!-- <ul class="checkbox-items"> -->
                      <span *ngFor="let item of accessList">
                        <input type="checkbox" [(ngModel)]="item.isChecked" (change)="changeSelection( item.label ,  $event.target.checked)"> <span style="margin-left: 10px;margin-right: 10px ">{{item.label}}</span>
                      </span>
                    <!-- </ul> -->



                </div>
            </div>


          </div>
          <div class="col-md-4" ></div>
        </div>
  
  
        <div class="row text-center mt-3">
                <div class="col-md-12">
                  <button [disabled]="adminName == '' || adminType =='' ||adminPassword == ''" (click)="addAdmin()" c class="btn-wide mb-2 me-2 btn btn-primary">Add Admin
                  </button>
          </div>
        </div>
      </div>
    </div>
  </div>

      </div>






</div>